// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1oTAB","left":"InfoRow_left__CGpUT"};